import React from 'react';

const DashboardGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                d="M72 32c26.51 0 48 21.64 48 48.333 0 12.114-4.275 23.184-11.586 31.667H35.586C28.276 103.518 24 92.447 24 80.333 24 53.64 45.49 32 72 32"
                fill="#FFF"
                fillRule="nonzero"
            />
            <path
                d="M72 32c26.51 0 48 21.64 48 48.333 0 12.114-4.275 23.184-11.586 31.667H35.586C28.276 103.518 24 92.447 24 80.333 24 53.64 45.49 32 72 32z"
                stroke="#1E0A3C"
                strokeWidth={3.31}
            />
            <path
                d="M35.586 80.333c0-20.25 16.304-36.666 36.414-36.666 20.11 0 36.414 16.416 36.414 36.666 0 6.682-3.31 15-6.62 20H42.206c-3.31-5-6.62-13.318-6.62-20"
                fill="#DBDAE3"
                fillRule="nonzero"
            />
            <path
                d="M72 82v18.333H42.207c-3.31-5-6.62-13.318-6.62-20 0-9.7 3.748-18.515 9.856-25.075L72 82z"
                fill="#F05537"
                fillRule="nonzero"
            />
            <path
                d="M68.69 77L46.254 54.408"
                stroke="#1E0A3C"
                strokeWidth={3.31}
            />
            <path
                d="M67.034 80.333c0 2.76 2.225 5 4.966 5s4.966-2.24 4.966-5-2.225-5-4.966-5-4.966 2.24-4.966 5"
                fill="#FFF"
                fillRule="nonzero"
            />
            <path
                d="M67.034 80.333c0 2.76 2.225 5 4.966 5s4.966-2.24 4.966-5-2.225-5-4.966-5-4.966 2.24-4.966 5zM72 37v3.333M88.552 40.333v3.334M110.069 62v3.333M101.793 50.333v3.334M113.38 78.667V82M55.448 40.333v3.334M33.931 62v3.333M42.207 50.333v3.334M30.62 78.667V82"
                stroke="#1E0A3C"
                strokeWidth={3.31}
            />
        </g>
    </svg>
);

DashboardGraphicSvg.displayName = 'DashboardGraphicSvg';
export default DashboardGraphicSvg;
